import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './i18n/locales/en.json';
import fr from './i18n/locales/fr.json';

i18n
    .use(initReactI18next)
    .init({
        resources: {
            en: { translation: en },
            fr: { translation: fr }
        },
        lng: localStorage.getItem('language') || 'en', // set default language
        fallbackLng: 'en',
        interpolation: {
            escapeValue: false // React already escapes values
        },
        returnEmptyString: false
    });

export default i18n;